export default "__VITE_ASSET__Cg4L1EaN__"